import { Controller } from "@hotwired/stimulus";

const STORAGE_KEY = "admin:chat-sidebar:open";
const WIDTH_STORAGE_KEY = "admin:chat-sidebar:width";
const OPEN_CLASS = "chat-sidebar-open";
const SIDEBAR_ID = "chat-sidebar";
const MIN_WIDTH = 320;
const MAX_WIDTH = 720;

export class ChatSidebarController extends Controller {
  connect() {
    const sidebar = this.sidebar;
    if (sidebar && localStorage.getItem(STORAGE_KEY) === "1" && !sidebar.classList.contains(OPEN_CLASS)) {
      // Restore without animating.
      sidebar.classList.add("regi-resizing");
      sidebar.classList.add(OPEN_CLASS);
      sidebar.offsetWidth;
      sidebar.classList.remove("regi-resizing");
    }
    this.restoreWidth();
  }

  toggle(event) {
    event?.preventDefault?.();
    const sidebar = this.sidebar;
    if (!sidebar) return;
    const open = sidebar.classList.toggle(OPEN_CLASS);
    localStorage.setItem(STORAGE_KEY, open ? "1" : "0");
  }

  close() {
    this.sidebar?.classList.remove(OPEN_CLASS);
    localStorage.setItem(STORAGE_KEY, "0");
  }

  restoreWidth() {
    const stored = parseInt(localStorage.getItem(WIDTH_STORAGE_KEY), 10);
    if (stored) this.applyWidth(stored);
  }

  applyWidth(width) {
    const clamped = Math.min(MAX_WIDTH, Math.max(MIN_WIDTH, width));
    this.sidebar?.style.setProperty("--regi-sidebar-width", `${clamped}px`);
    return clamped;
  }

  startResize(event) {
    const sidebar = this.sidebar;
    if (!sidebar) return;
    event.preventDefault();

    const handle = event.currentTarget;
    handle.setPointerCapture(event.pointerId);

    const startX = event.clientX;
    const startWidth = sidebar.getBoundingClientRect().width;
    sidebar.classList.add("regi-resizing");
    document.body.style.userSelect = "none";
    document.body.style.cursor = "col-resize";

    const onMove = (e) => this.applyWidth(startWidth + (startX - e.clientX));
    const onUp = () => {
      handle.removeEventListener("pointermove", onMove);
      handle.removeEventListener("pointerup", onUp);
      handle.removeEventListener("lostpointercapture", onUp);
      sidebar.classList.remove("regi-resizing");
      document.body.style.userSelect = "";
      document.body.style.cursor = "";
      const finalWidth = Math.round(sidebar.getBoundingClientRect().width);
      localStorage.setItem(WIDTH_STORAGE_KEY, String(finalWidth));
    };

    handle.addEventListener("pointermove", onMove);
    handle.addEventListener("pointerup", onUp);
    handle.addEventListener("lostpointercapture", onUp);
  }

  get sidebar() {
    return document.getElementById(SIDEBAR_ID);
  }
}
